const nps = {
  nps: {
    npsBreakdown: 'Desglose del NPS',
    npsScore: 'Puntuación del NPS',
    npsSpread: 'Dispersión del NPS',
    npsDashboard: 'PANEL del NPS',
    npsDetails: 'Detalles de NPS',
    npsTrend: 'Tendencia del NPS',
    verbatims: 'Verbatims',
    timePeriod: 'Período de tiempo: ',
    to: 'a',
    pastMonths: 'los últimos %{month} meses',
    ratingType: 'Tipo de clasificación',
    systemId: 'ID del sistema',
    systemName: 'Nombre del sistema',
    rating: 'Clasificación',
    comments: 'Comentarios',
    all: 'Todo',
    promoter: 'Promotor',
    promoters: 'Promotores',
    detractor: 'Detractor',
    detractors: 'Detractores',
    passive: 'Pasivo',
    noData: 'Sin datos disponibles',
    npsDashboardTooltip: {
      whatIs: '¿Qué es el Índice Neto de Promotores?',
      npsDefine:
        'El Índice Neto de Promotores es un índice que varía de -100 a 100 que mide la disposición de clientes de recomendar una compañía a otras personas. Se usa como un indicador para medir la satisfacción general de los clientes.',
      questionIs:
        'La pregunta está expresada como "En una escala de 0 a 10, ¿cuán probable es que recomiende nuestra organización a un amigo o colega?" En base al número que elige un cliente, se clasifican en una de las siguientes categorías: “Detractores," "Pasivos" y "Promotores". Desglose de puntuación: 0 - 6: Detractores, 7 - 8: Pasivos, 9 - 10: Promotores',
      determined:
        'El Índice Neto de Promotores (NPS) se determina sustrayendo el porcentaje de clientes que son detractores al porcentaje que son promotores. Lo que se genera es una puntuación entre -100 y 100 llamada Índice Neto de Promotores.',
      how: '¿Cómo determina Enphase el NPS para ti?',
      shownBelow:
        'Enphase le pide a los propietarios de vivienda que proporcionen calificaciones en la aplicación móvil Enlighten como se muestra en las siguientes pantallas. En base a las calificaciones proporcionadas, el NPS se determina como se describió anteriormente.'
    },
    timePeriodTooltip:
      'El período de tiempo predeterminado es de al menos 13 meses. Si la puntuación de NPS no está disponible para los últimos 13 meses, entonces la puntuación se incluye desde el primer mes disponible.',
    verbatimsTooltip:
      'Todos los comentarios que se muestran aquí son de propietarios del sistema que han dado su consentimiento para compartirlos con los instaladores.',
    jan: "Ene'",
    feb: "Feb'",
    mar: "Mar'",
    apr: "Abr'",
    may: "Mayo'",
    jun: "Jun'",
    jul: "Jul'",
    aug: "Ago'",
    sep: "Sep'",
    oct: "Oct'",
    nov: "Nov'",
    dec: "Dic'",
    ofTotal: 'del total',
    ratings: 'Clasificaciones',
    numberOfReviews: 'Cantidad de reseñas',
    date: 'Fecha',
    between0And10: 'Escriba un valor entre 0 y 10',
    lessThan50: 'El número de caracteres debe ser inferior a 50',
    npsBasedOnScore: `NPS de %{score} basado en las calificaciones %{count} `
  }
};

export default nps;
